/**
 * Generate a hash code for any particular string
 * 
 * Based on: https://stackoverflow.com/a/7616484
 * 
 * @param value_unhashed string | null | undefined
 * @returns number
 */
export const hashCode = (value_unhashed?: string | null | undefined) => {
  const input = value_unhashed || "";

  let hash = 0,
    i,
    chr;
  if (input.length === 0) return hash;
  for (i = 0; i < input.length; i++) {
    chr = input.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};
